<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import {
  DropdownContainer,
  DropdownBody,
  DropdownSection,
  DropdownItem,
} from 'dashboard/components-next/dropdown-menu/base';

// CRM-01h: o pipeline é o título do quadro, e trocar de pipeline é escolher outro título. Era um
// select nativo que herdava o estilo global de select (triângulo cinza e margem embaixo).
const props = defineProps({
  pipelines: { type: Array, default: () => [] },
  activeId: { type: Number, default: null },
});

const emit = defineEmits(['select']);

const { t } = useI18n();

const ativo = computed(() =>
  props.pipelines.find(pipeline => pipeline.id === props.activeId)
);
</script>

<template>
  <DropdownContainer>
    <template #trigger="{ toggle, isOpen }">
      <button
        type="button"
        class="flex items-center min-w-0 gap-1 px-1.5 -ms-1.5 h-8 rounded-lg hover:bg-n-alpha-1"
        :class="{ 'bg-n-alpha-1': isOpen }"
        :aria-label="t('KANBAN.PIPELINE.SWITCH')"
        :aria-expanded="isOpen"
        @click="toggle"
      >
        <span
          class="text-base font-semibold truncate text-n-slate-12 tracking-[-0.01em]"
        >
          {{ ativo?.name }}
        </span>
        <Icon
          icon="i-lucide-chevron-down"
          class="flex-shrink-0 size-4 text-n-slate-11"
        />
      </button>
    </template>
    <DropdownBody class="z-50 mt-1 min-w-56">
      <DropdownSection class="[&>ul]:grid-cols-1">
        <DropdownItem
          v-for="pipeline in pipelines"
          :key="pipeline.id"
          class="cursor-pointer"
          @click="emit('select', pipeline.id)"
        >
          <template #label>
            <span class="min-w-0 truncate text-n-slate-12">
              {{ pipeline.name }}
            </span>
            <Icon
              v-if="pipeline.id === activeId"
              icon="i-lucide-check"
              class="flex-shrink-0 ms-auto size-4 text-n-teal-11"
            />
          </template>
        </DropdownItem>
      </DropdownSection>
    </DropdownBody>
  </DropdownContainer>
</template>
